export default __webpack_public_path__ + "static/bluford-2ef1395bfea4369dccc992b499ad12be.jpg";